Element.prototype.isVisible = function() {
    return !!( this.offsetWidth || this.offsetHeight || this.getClientRects().length );
};
